import testUser from '../../mocks/testUser';
import { actorSummaryReport, actorReport } from '../../config/filters';

const actorsConfig = {
  testUser,
  ACTOR_PAGE_ID: 'actorReport',
  ACTOR_SUMMARY_PAGE_ID: 'actorSummaryReport',
  ACTOR_SUMMARY_FILTERS: actorSummaryReport,
  ACTOR_REPORT_FILTERS: actorReport
};

export default actorsConfig;
